import { AppLocale } from "../../types";

export const localeTextMap: Record<Partial<AppLocale>, string> = {
  ru_RU: "Ru",
  en_US: "En",
};
